// @flow
import React from 'react';
import classNames from 'classnames/bind';

import PlainLink from 'app/common/ui-next/plain-link';
import IconTask from 'app/common/icons/IconTask';
import SimpleDate from 'app/dataProviders/SimpleDate';

import MoreLink from '../MoreLink';
import styles from './CardTasks.scss';


type Props = {
  className: string,
  date: SimpleDate,
  studentId: string,
  dayTasks: Array<{
    id: string,
    text: string,
    comment: string,
  }>,
}

const CardTasks = ({
  className,
  date,
  studentId,
  dayTasks,
}: Props) => {
  const link = `/apps/${studentId}/dnevnik/home`;
  const title = `Задано на ${date.getString('D MMMM')}`;

  return (
    <div className={classNames(styles.root, className)}>
      <div className={styles.header}>{title}</div>

      {dayTasks.map(item =>
        <div className={styles.item} key={item.id}>
          {item.text}
          <div className={styles.comment}>{item.comment}</div>
        </div>)}

      <PlainLink to={link} className={styles.icon}>
        <IconTask />
      </PlainLink>

      <MoreLink to={link} />
    </div>
  );
};

export default CardTasks;
